import type { FaireProductEntity } from "../../entity_types/product";

export const p_tekngekac8: FaireProductEntity = {
  token: "p_tekngekac8",
  type: "product",
  name: "Swedish Candy Canes - Pack of 20 Peppermint",
  brandToken: "b_4ecnlfrq9x",
  brandName: "Sockerbit",
  imageUrl:
    "https://cdn.faire.com/fastly/4ebc9eb4eecd40118f5e9b9b817ff600c96be2ae1701ce7b8cd277457827c2d5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c84e906fe0a4f866121e67f7c7002f8d65d8762192fa41d9e532a30aa47680ed.png",
    "https://cdn.faire.com/fastly/6c6e46d7719cea56d9a6a53b67fdc341e60cfa93df6f8e214e59301ca373c178.png",
  ],
  priceDollars: 2.95,
  description:
    "Swedish candy canes are called Polkagris, and their story is an example of some early-day lady entrepreneurial power in Sweden. In the 1830s, when candy canes were soon to see the light as Polkagrisar, Amalia Eriksson, an inhabitant of the little town of Gränna, started making candy sticks after her husband passed away. She kept the recipe secret, and was the only one in town to make the red and white swirly candy sticks that soon became a successful business, continued by her daughter after her death. All travellers on their way between Gothenburg and Stockholm would stop by the little shop in Gränna to get their supply of deliciousness. The recipe was shared later on, and it became a traditional candy for the women of Gränna to make. Nowadays, Polkagris is still produced with the original recipe in the small town of Gränna, where you can go peek into the kitchen of the candy stores to see how they are made!\n\nPack of 20 Peppermint Swedish Candy Canes.",
  tags: [],
  msrpDollars: 5.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:20.071Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
